@let activeSubscription = activeSubscription$ | async;

<div id="step6">
  <div class="bloc">
    <div class="trialBloc" appAppear (event)="anim = true">
      <div class="image">
        <img src="assets/images/svg/emoticonParty.svg" alt="It's Party Time" />
      </div>
      <div class="text">
        <h5>
          {{ 'homepage.step6.trial.title.first' | translate }}
          <span>{{ 'homepage.step6.trial.title.second' | translate }}</span>
          <span class="blue">*</span>
        </h5>
        <p>
          <span class="blue">*</span>
          {{ 'homepage.step6.trial.subTitle' | translate }}
        </p>
      </div>
    </div>

    <div class="mode-switch-wrapper">
      @let currency = currency$ | async;
      <kin-multi-switch (selectedValueChange)="updateCurrency($event)" [selectedValue]="currency" mainColor="#ffffff"
        [options]="[
        {
        label: ('price_card.currency_switch.eur' | translate),        
        value:'eur',
        icon:'circle_euro'
      },{
        label: ('price_card.currency_switch.usd' | translate),        
        value:'usd',
        icon:'circle_dollar'
      }]" />

    </div>

    <div class="formule">
      @for (product of products$ | async; track $index) {
      <div class="formuleBloc" [ngClass]="anim ? 'active' : ''">

        @if(product.name === 'lifetime'){
        <div class="formule-banner">
          <p>{{ ('homepage.step6.lifetime_expiration' | translate).replace('{ daysLeft }', lifetimeDaysLeft) }}</p>
        </div>
        }


        <div class="top">
          <div class="image">
            <app-picture [convertToWebp]="false" [src]="
                  'assets/images/subscriptions/' + product.name + '-sub.png'
                " alt="icon" />
          </div>

          <div class="text">
            <h5>
              {{
              'stripePlans.' + product.name + '.name'
              | translate
              | titlecase
              }}
            </h5>
            <p>{{ 'stripePlans.startAt' | translate }}</p>
            <p class="price">
              <span [animateOnChange]="product.price | formatPrice: (currency$ | async)">
                {{ product.price | formatPrice: (currency$ | async) }}
              </span>
              <span> {{
                'stripePlans.' + product.name + '.duration' | translate
                }}</span>
            </p>
            <p>
              <span class="offer">
                {{ 'stripePlans.soloOffer' | translate }}
              </span>
              <span style="margin-left: 5px; white-space: nowrap">
                = {{ 'stripePlans.1user' | translate }}
              </span>
            </p>
          </div>
        </div>

        <p class="accroche">
          "{{ 'stripePlans.' + product.name + '.accroche' | translate }}"
        </p>

        <div class="family-container">
          @if (product.name !== 'lifetime') {
          <hr />
          <div class="family">
            <div class="image">
              <img src="assets/images/rate/family.svg" alt="icon_family" />
            </div>

            <div class="content">
              <p>{{ 'stripePlans.family.availableIn' | translate }}</p>
              <span>{{
                'stripePlans.family.familyOption' | translate
                }}</span>
            </div>
          </div>
          } @else {
          <hr />
          <div class="family">
            <div class="content">
              <p>
                {{
                ((settings$ | async)?.default_date_format?.split(' ')[2]
                ? 'dashboard.subscription.info.lifetime-expire-us'
                : 'dashboard.subscription.info.lifetime-expire'
                ) | translate
                }}
              </p>
            </div>
          </div>
          }
        </div>
        <div class="bottom">
          @let isActiveMobileSubscription =
          activeSubscription?.origin === 'ios' ||
          activeSubscription?.origin === 'android';
          @let isAvailable =
          isPlanAvailable(product, activeSubscription) &&
          !isActiveMobileSubscription;
          @let displayBtn = activeSubscription?.plan.name !== product.name;
          <a (click)="navitageToCart(product)" class="product" [class.btn-primary]="displayBtn"
            [class.btn-disabled]="displayBtn && !isAvailable">
            @if (!displayBtn) {
            {{
            'dashboard.subscription.info.subscriptionActive' | translate
            }}
            } @else {
            {{ 'stripePlans.btn' | translate }}
            }
          </a>
        </div>
      </div>
      }
    </div>
  </div>

  @if (!onlyProducts) {
  <div class="fond">
    <div class="gradient"></div>
    <app-picture src="assets/images/backgrounds/brian-erickson.png" alt="Photo of Brian Erickson" />
  </div>

  <div class="mobileFond">
    <div class="gradient"></div>
    <app-picture src="assets/images/backgrounds/brian-erickson.png" alt="Photo of Brian Erickson" />
  </div>

  <div class="upload" appAppear (event)="anim2 = true">
    <div class="left">
      <div class="top">
        <div class="gradient"></div>
        <picture>
          <source srcset="assets/images/backgrounds/camera.webp" type="image/webp" />
          <img src="assets/images/backgrounds/camera.png" alt="Camera GoPro gradient" />
        </picture>
        <div class="content">
          <h5>{{ 'homepage.step6.upload.title' | translate }}</h5>
          <p>{{ 'homepage.step6.upload.subTitle' | translate }}</p>
          <a (click)="navToUpload()" class="btn-primary">{{
            'homepage.step6.upload.btn' | translate
            }}</a>
        </div>
      </div>
      <div class="thumbList">
        <div class="one" [ngClass]="anim2 ? 'active' : ''">
          <div class="card">
            <div class="pic">
              <img src="assets/images/icons/upload_icon.svg" alt="upload_icon" />
            </div>
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/3rtp5j.jpg"
              alt="Video Thumb" />
          </div>
          <div class="card">
            <div class="pic">
              <img src="assets/images/icons/upload_icon.svg" alt="upload_icon" />
            </div>
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/4f59t6.jpg"
              alt="Video Thumb" />
          </div>
          <div class="card">
            <div class="pic">
              <img src="assets/images/icons/upload_icon.svg" alt="upload_icon" />
            </div>
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/4vac6u.jpg"
              alt="Video Thumb" />
          </div>
        </div>
        <div class="two" [ngClass]="anim2 ? 'active' : ''">
          <div class="card">
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/54a8wp.jpg"
              alt="Video Thumb" />
          </div>
          <div class="card">
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/htewja.jpg"
              alt="Video Thumb" />
          </div>
          <div class="card">
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/vjphxa.jpg"
              alt="Video Thumb" />
          </div>
          <div class="card">
            <app-picture style="width: 320px; height: 240px; margin-top: -30px" src="assets/images/thumbs/xny78a.jpg"
              alt="Video Thumb" />
          </div>
        </div>
      </div>
    </div>

    <div class="right">
      <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1156 0.676337C14.4908 -0.0348094 15.5092 -0.0348076 15.8844 0.676339L19.6609 7.83409C19.8056 8.10834 20.0693 8.29995 20.3749 8.35281L28.3493 9.73259C29.1416 9.86967 29.4563 10.8383 28.8959 11.4149L23.2555 17.2184C23.0394 17.4408 22.9386 17.7508 22.9828 18.0577L24.1348 26.0682C24.2492 26.8641 23.4253 27.4627 22.7037 27.108L15.4412 23.537C15.163 23.4001 14.837 23.4001 14.5588 23.537L7.29629 27.108C6.57474 27.4627 5.75078 26.8641 5.86523 26.0682L7.01722 18.0577C7.06136 17.7508 6.96062 17.4408 6.74451 17.2184L1.10408 11.4149C0.543682 10.8383 0.858412 9.86967 1.6507 9.73259L9.62512 8.35281C9.93066 8.29995 10.1944 8.10834 10.3391 7.83409L14.1156 0.676337Z"
          fill="#FFC947" />
      </svg>
      <h5>{{ 'homepage.step6.reward.title' | translate }}</h5>
      <p innerHTML="{{
            'homepage.step6.reward.subTitleHTML' | translate
          }}"></p>
      <a [href]="rewardLink" target="_blank" rel="noopener noreferrer" class="btn-primary">{{
        'homepage.step6.reward.btn' | translate }}</a>
    </div>
  </div>
  }
</div>